interface SetupProgressBarProps {
  progress: number
}

export function SetupProgressBar({ progress }: SetupProgressBarProps) {
  return (
    <div class="w-full mb-6">
      <div class="h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          class="h-full bg-blue-600 transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div class="text-xs text-gray-500 text-center mt-2">
        Setup Progress: {progress}%
      </div>
    </div>
  )
}
